import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";


import HospitalMaster from "../../HospitalPages/HospitalAdmin/HospitalMaster";
import DepartmentMaster from "../../HospitalPages/HospitalAdmin/DepartmentMaster";
import HospitalUserManagement from "../../HospitalPages/HospitalAdmin/HospitalUserManagement";
import HospitolAuditLog from "../../HospitalPages/HospitalAdmin/HospitolAuditLog";
import HospitalDataBackup from "../../HospitalPages/HospitalAdmin/HospitalDataBackup";
import HospitalSystemConfiguration from "../../HospitalPages/HospitalAdmin/HospitalSystemConfiguration";
import { decrypt } from "../../components/cryptoUtil";
import DashboardCards from "../HospitalDashBoardCards";
import { includeCardForRoles, ROLES } from "../componenet/heading";


const HospitalAdminDashBoard = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
const tokenData = localStorage.getItem("tokenData");
    const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
    const userName = decryptedData.userfullname || "";
const userRole = decryptedData.userrole || "";


const cardRoles = {
  "Hospital Master": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "Department Master": [ROLES.RECEPTIONIST],   // only userRole 102 can see
  "User & Role Management": [ROLES.RECEPTIONIST],
  "Audit Log": [ROLES.STAFF],
  "Data Backup & Restore": [ROLES.ACCOUNTSECTION],
  "System Configuration": [ROLES.DOCTOR,ROLES.RECEPTIONIST],
};



   const cards = [
    ...includeCardForRoles(cardRoles["Hospital Master"], userRole,{
      title: "Hospital Master",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
      component: <HospitalMaster />,category: "👨‍⚕️ Hospital Admin Data Management",
    }),
    ...includeCardForRoles(cardRoles["Department Master"], userRole,{
      title: "Department Master",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
      component: <DepartmentMaster />,category: "👨‍⚕️ Hospital Admin Data Management",
    }),
   
    ...includeCardForRoles(cardRoles["User & Role Management"], userRole,{
      title: "User & Role Management",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
      component: <HospitalUserManagement />,category: "👨‍⚕️ Hospital Admin Data Management",
    }),
    ...includeCardForRoles(cardRoles["Audit Log"], userRole,{
      title: "Audit Log",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <HospitolAuditLog />,category: "👨‍⚕️ Hospital Admin Data Management",
    }),
     ...includeCardForRoles(cardRoles["Data Backup & Restore"], userRole,{
      title: "Data Backup & Restore",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <HospitalDataBackup />,category: "👨‍⚕️ Hospital Admin Data Management",
    }),

    ...includeCardForRoles(cardRoles["System Configuration"], userRole,{
      title: "System Configuration",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <HospitalSystemConfiguration />,category: "👨‍⚕️ Hospital Admin Data Management",
    }),


  ];
//👨‍⚕️ Hospital Admin Data Management
 
  
     return (
      <DashboardCards
        cards={cards}
        menulabel={1}
        welcomeMessage={
          <Typography variant="h5" align="center" gutterBottom>
           
            👨‍⚕️ Hospital Admin Data Management
          </Typography>
        }
      />
    );
  };

export default HospitalAdminDashBoard;
